import BiddingsTable from './biddings-table';

export default BiddingsTable;
